module.exports = __webpack_public_path__ + "images/socialite-75e57d579b556e5296c32dc591533892.png";